import { render, staticRenderFns } from "./member-workSheetDetail.vue?vue&type=template&id=2b8d476a&scoped=true&"
import script from "./member-workSheetDetail.vue?vue&type=script&lang=js&"
export * from "./member-workSheetDetail.vue?vue&type=script&lang=js&"
import style0 from "./member-workSheetDetail.vue?vue&type=style&index=0&id=2b8d476a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d476a",
  null
  
)

component.options.__file = "member-workSheetDetail.vue"
export default component.exports